import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, Transition as _Transition, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = { style: {"min-width":"220px"} }
const _hoisted_6 = {
  key: 0,
  class: "badge bg-white text-primary rounded-pill ms-1",
  style: {"font-size":"11px","min-width":"20px"}
}
const _hoisted_7 = {
  key: 0,
  class: "filter-panel border-top border-bottom bg-light px-4 py-3"
}
const _hoisted_8 = { class: "row g-3" }
const _hoisted_9 = { class: "col-md-4 col-lg-3" }
const _hoisted_10 = { class: "col-md-4 col-lg-3" }
const _hoisted_11 = { class: "col-md-4 col-lg-3" }
const _hoisted_12 = { class: "col-md-4 col-lg-3" }
const _hoisted_13 = { class: "col-md-4 col-lg-3" }
const _hoisted_14 = { class: "col-md-4 col-lg-3" }
const _hoisted_15 = { class: "col-12 d-flex align-items-center gap-2 pt-2 border-top mt-1" }
const _hoisted_16 = {
  key: 0,
  class: "text-muted small ms-2"
}
const _hoisted_17 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "switch" }
const _hoisted_22 = ["id", "checked", "onChange"]
const _hoisted_23 = ["for"]
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "dropdown" }
const _hoisted_26 = { class: "dropdown-menu" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 2 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 4 }
const _hoisted_36 = {
  class: "modal fade",
  id: "modal_login_user",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_37 = { class: "modal-dialog modal-xl" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = { class: "modal-body" }
const _hoisted_40 = { class: "card-body" }
const _hoisted_41 = { class: "d-flex" }
const _hoisted_42 = {
  class: "mb-0 me-1",
  style: {"width":"100%"}
}
const _hoisted_43 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_DeliveryProviderFormModal = _resolveComponent("DeliveryProviderFormModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
            to: "/add-user"
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode(" Nouveau Utilisateur ", -1),
              _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
            ])),
            _: 1,
            __: [13]
          }),
          _cache[15] || (_cache[15] = _createElementVNode("button", {
            class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
            type: "button"
          }, [
            _createTextVNode(" Export "),
            _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" })
          ], -1)),
          _createVNode(_component_router_link, {
            to: "/driver-status-api-docs",
            class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block ms-10 mb-10 mb-lg-0 text-decoration-none"
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode(" Documentation API – Changement de statut ", -1),
              _createElementVNode("i", { class: "ph ph-book-open position-relative ms-5 top-1" }, null, -1)
            ])),
            _: 1,
            __: [14]
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control text-black rounded-1",
              placeholder: "Recherche rapide...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.users.searchTerm) = $event)),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onQuickSearch && _ctx.onQuickSearch(...args)))
            }, null, 544), [
              [_vModelText, _ctx.users.searchTerm]
            ])
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["btn d-flex align-items-center gap-2 fw-medium", _ctx.showFilters ? 'btn-primary' : 'btn-outline-secondary']),
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
          }, [
            _createVNode(_component_feather_icon, {
              icon: "SlidersIcon",
              size: "15"
            }),
            _cache[16] || (_cache[16] = _createTextVNode(" Filtres ", -1)),
            (_ctx.activeFiltersCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.activeFiltersCount), 1))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _createVNode(_Transition, { name: "filter-slide" }, {
        default: _withCtx(() => [
          (_ctx.showFilters)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { class: "filter-label" }, "Nom complet", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.users.searchName) = $event)),
                      type: "text",
                      class: "form-control form-control-sm",
                      placeholder: "Chercher par nom..."
                    }, null, 512), [
                      [_vModelText, _ctx.users.searchName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "filter-label" }, "Fonction", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.selectedFunction,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedFunction) = $event)),
                      options: _ctx.FunctionsList,
                      label: "name",
                      placeholder: "Toutes les fonctions",
                      onSearch: _ctx.onSearchFunct,
                      class: "vs--sm"
                    }, {
                      "no-options": _withCtx(() => _cache[18] || (_cache[18] = [
                        _createElementVNode("span", { class: "text-muted small" }, "Taper pour chercher...", -1)
                      ])),
                      _: 1
                    }, 8, ["modelValue", "options", "onSearch"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "filter-label" }, "Ville", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.selectedCity,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCity) = $event)),
                      options: _ctx.CitiesList,
                      label: "name",
                      placeholder: "Toutes les villes",
                      class: "vs--sm"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "filter-label" }, "Zone", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.selectedZone,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedZone) = $event)),
                      options: _ctx.ZonesList,
                      label: "name",
                      placeholder: "Toutes les zones",
                      class: "vs--sm"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "filter-label" }, "Statut du compte", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.users.searchAccount) = $event)),
                      class: "form-select form-select-sm"
                    }, _cache[22] || (_cache[22] = [
                      _createElementVNode("option", { value: "" }, "Tous", -1),
                      _createElementVNode("option", { value: 1 }, "Compte activé", -1),
                      _createElementVNode("option", { value: 0 }, "Compte désactivé", -1)
                    ]), 512), [
                      [_vModelSelect, _ctx.users.searchAccount]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[25] || (_cache[25] = _createElementVNode("label", { class: "filter-label" }, "Créé par", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.selectedCreatedBy,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedCreatedBy) = $event)),
                      options: _ctx.CuserList,
                      label: "name",
                      placeholder: "Tous les utilisateurs",
                      onSearch: _ctx.onSearchUsers,
                      class: "vs--sm"
                    }, {
                      "no-options": _withCtx(() => _cache[24] || (_cache[24] = [
                        _createElementVNode("span", { class: "text-muted small" }, "Taper pour chercher...", -1)
                      ])),
                      _: 1
                    }, 8, ["modelValue", "options", "onSearch"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary px-4 d-flex align-items-center gap-1",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                    }, [
                      _createVNode(_component_feather_icon, {
                        icon: "FilterIcon",
                        size: "14"
                      }),
                      _cache[26] || (_cache[26] = _createTextVNode(" Appliquer les filtres ", -1))
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-secondary d-flex align-items-center gap-1",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                    }, [
                      _createVNode(_component_feather_icon, {
                        icon: "RotateCcwIcon",
                        size: "14"
                      }),
                      _cache[27] || (_cache[27] = _createTextVNode(" Réinitialiser ", -1))
                    ]),
                    (_ctx.activeFiltersCount > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.activeFiltersCount) + " filtre" + _toDisplayString(_ctx.activeFiltersCount > 1 ? 's' : '') + " actif" + _toDisplayString(_ctx.activeFiltersCount > 1 ? 's' : ''), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.headers,
          rows: _ctx.rows
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[28] || (_cache[28] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [28]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field == 'created_at')
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
              : (props.column.field == 'logout_time')
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(props.row.logout_time ? _ctx.getDate(props.row.logout_time) : ""), 1))
                : (props.column.field == 'active')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "switch-input",
                          id: 'switch-' + props.row.id,
                          checked: props.row.active,
                          onChange: ($event: any) => (_ctx.toggleAdActive(props.row))
                        }, null, 40, _hoisted_22),
                        _createElementVNode("label", {
                          class: "switch-label",
                          for: 'switch-' + props.row.id
                        }, null, 8, _hoisted_23)
                      ])
                    ]))
                  : (props.column.field == 'actions')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _cache[34] || (_cache[34] = _createElementVNode("button", {
                            class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_26, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: _withModifiers(($event: any) => (
                      _ctx.$router.push({
                        name: 'EditUserPage',
                        params: { id: props.row.id },
                      })
                    ), ["prevent"])
                              }, _cache[29] || (_cache[29] = [
                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Modifier ", -1)
                              ]), 8, _hoisted_27)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: _withModifiers(($event: any) => (
                      _ctx.$router.push({
                        name: 'HistoryUserPage',
                        params: { id: props.row.id },
                      })
                    ), ["prevent"])
                              }, _cache[30] || (_cache[30] = [
                                _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Historique ", -1)
                              ]), 8, _hoisted_28)
                            ]),
                            (Number(props.row.role_id) === 4)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: _withModifiers(($event: any) => (_ctx.openDriverReturnPdf(props.row)), ["prevent"])
                                  }, _cache[31] || (_cache[31] = [
                                    _createElementVNode("i", { class: "ph ph-file-pdf lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode("Rapport des retours (PDF) ", -1)
                                  ]), 8, _hoisted_30)
                                ]))
                              : _createCommentVNode("", true),
                            (Number(props.row.role_id) === 4)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: _withModifiers(($event: any) => (_ctx.openDriverProvider(props.row)), ["prevent"])
                                  }, [
                                    _cache[32] || (_cache[32] = _createElementVNode("i", { class: "ph ph-plugs-connected lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(props.row.delivery_provider_id ? "Configuration prestataire" : "Établir comme prestataire"), 1)
                                  ], 8, _hoisted_32)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.auth.can('CONNEXION_USER'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (_ctx.hashUser(props.row))
                                  }, _cache[33] || (_cache[33] = [
                                    _createElementVNode("i", { class: "ph ph-sign-in lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Login ", -1)
                                  ]), 8, _hoisted_34)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users,
          offset: 9,
          onPaginate: _ctx.fetchData
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createVNode(_component_DeliveryProviderFormModal, {
      ref: "providerModal",
      onSaved: _cache[11] || (_cache[11] = ($event: any) => (_ctx.fetchData(_ctx.users.current_page)))
    }, null, 512),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Url de connexion"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _cache[36] || (_cache[36] = _createElementVNode("div", {
                class: "alert alert-warning",
                role: "alert"
              }, " Merci d'ouvrir ce lien dans un autre navigateur ou de vous connecter avec ce lien après vous être déconnecté. ", -1)),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("input", {
                    value: _ctx.hashData,
                    readonly: "",
                    class: "form-control"
                  }, null, 8, _hoisted_43)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary d-inline-flex align-items-center text-nowrap",
                  title: "Copier le lien",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.copyLoginLink && _ctx.copyLoginLink(...args)))
                }, _cache[35] || (_cache[35] = [
                  _createElementVNode("i", { class: "flaticon-copy me-1" }, null, -1),
                  _createTextVNode(" Copier ", -1)
                ]))
              ])
            ])
          ]),
          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Fermer")
          ], -1))
        ])
      ])
    ])
  ], 64))
}